import { render, staticRenderFns } from "./judges.vue?vue&type=template&id=15f08c88&scoped=true"
import script from "./judges.vue?vue&type=script&lang=js"
export * from "./judges.vue?vue&type=script&lang=js"
import style0 from "./judges.vue?vue&type=style&index=0&id=15f08c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f08c88",
  null
  
)

export default component.exports